import React, { useEffect, useState } from "react";
import {Link, useNavigate, useSearchParams} from 'react-router-dom';
import RegistrationForm from "./components/RegistrationForm";
import {useDispatch, useSelector} from "react-redux";
import {ThunkDispatch} from "@reduxjs/toolkit";
import {register, setIsLoadingRegister, setUrlSlug, setCompanyInfo, checkTalentRegistrationToken,
  getOptionsRelatedTalentRegister,
 } from "reducers/talentRegister";
import CustomToast from "components/CustomToast";
import {useSnackbar} from "notistack";
import { pushGoogleAnalytics } from "../../utils/gtag";
import Header from "../../components/Header";
import NotFoundPage from "../../pages/NotFoundPage";
import { validateNameKatakana, validateEmail, isValidJoinDateLeaveDate } from "../../utils/validation";
import { TYPE_MAP, TALENT_TYPE } from '../../constants/index'
import { getItemsDay, getNameByObject } from "../../utils/util";
import i18n from 'i18next';

const TalentRegistration = () => {
  const [searchParams] = useSearchParams();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();
  const { optionsRelatedCompany, actionStatus, actionName, talentCompany, isSuccess, isLoadingRegister, companyInfo, type,
    register_code, isShowTopPageUrl, reasonListItems, initialData, initialErrors, referrer_talent_id, talentOptionsRelatedRegister,
  } = useSelector((state: any) => state.talentRegister);

  const [formData, setFormData] = useState(initialData);
  const [errors, setErrors] = useState(initialErrors);
  
  const [isSendConfirmMail, setIsSendConfirmMail] = useState(false);
  const [dayOptions, setDayOptions] = useState([{id: -1, name: ""}]);
  const [dayOfLeaveOptions, setDayOfLeaveOptions] = useState([{id: -1, name: ""}]);
  const [cityOptions, setCityOptions] = useState([{id: -1, name: ""}]);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [showOtherReason, setShowOtherReason] = useState(false);
  const [checkingAccess, setCheckingAccess] = useState(true);
  const [jobType1Options, setJobType1Options] = useState([]);
  const [jobType2Options, setJobType2Options] = useState([]);
  const [jobType3Options, setJobType3Options] = useState([]);
  const [industry1Options, setIndustry1Options] = useState([]);
  const [industry2Options, setIndustry2Options] = useState([]);
  const [industry3Options, setIndustry3Options] = useState([]);
  const token = searchParams.get("t");

  const optionsList = {
    jobType1Options: jobType1Options,
    jobType2Options: jobType2Options,
    jobType3Options: jobType3Options,
    industry1Options: industry1Options,
    industry2Options: industry2Options,
    industry3Options: industry3Options,
    dayOptions: dayOptions,
    dayOfLeaveOptions: dayOfLeaveOptions,
    selectedOptions: selectedOptions,
    cityOptions: cityOptions,
    showOtherReason: showOtherReason,
    isSendConfirmMail: isSendConfirmMail,
  };

  const settersList = {
    setJobType1Options: setJobType1Options,
    setJobType2Options: setJobType2Options,
    setJobType3Options: setJobType3Options,
    setIndustry1Options: setIndustry1Options,
    setIndustry2Options: setIndustry2Options,
    setIndustry3Options: setIndustry3Options,
    setDayOptions: setDayOptions,
    setDayOfLeaveOptions: setDayOfLeaveOptions,
    setSelectedOptions: setSelectedOptions,
    setShowOtherReason: setShowOtherReason,
  };

  useEffect(() => {
    // Get company info
    if(token) {
      dispatch(checkTalentRegistrationToken({"token": token}));
    } else {
      setCheckingAccess(false);
    }

    // Get options related talent
    dispatch(getOptionsRelatedTalentRegister(null));

    // Google Analytics
    setTimeout(() => {
      addDataLayer()
    }, 5000);
  }, []);

  useEffect(() => {
    setJobType1Options(talentOptionsRelatedRegister?.jobTypeOptions.filter(item => item.parent_id == 0))
    setJobType2Options([])
    setJobType3Options([])

    setIndustry1Options(talentOptionsRelatedRegister?.industryOptions.filter(item => item.parent_id == 0))
    setIndustry2Options([])
    setIndustry3Options([])
  }, [talentOptionsRelatedRegister]);

  const gotoTalentRegistration = () => {
    window.location.href = sessionStorage.getItem('talent_registration_url');
  }

  useEffect(() => {
    if (actionStatus === 'fulfilled') {
      switch(actionName) {
        case 'checkTalentRegistrationToken':
          const company = optionsRelatedCompany?.company;
          dispatch(setCompanyInfo(company));
          setCityOptions(optionsRelatedCompany?.citys);
          if(company) {
            dispatch(setUrlSlug(`/new/${TYPE_MAP[type]}/${company.url_slug}`));
            localStorage.setItem("privacy_policy", company?.privacy_policy || "");
          }
          break;
        case 'talentRegister':
          dispatch(setIsLoadingRegister(false))
          if (isSuccess) {
            setIsSendConfirmMail(true)
            navigate("/talent/register-complete");
          }
          if (talentCompany.message == i18n.t('MSG_TALENT_REGISTRATION_TOKEN_EXPIRED')) {
            showToast("メッセージ", talentCompany.message, "error", "トップページへ戻る", gotoTalentRegistration);
          }
          else {
            showToast("メッセージ", talentCompany.message, isSuccess ? "success" : "error");
          }
        default:
          break;
      }
      setCheckingAccess(false);
    } else if (actionStatus === 'rejected') {
      setCheckingAccess(false);
    }
    setDayOptions(getItemsDay());
    setDayOfLeaveOptions(getItemsDay());
  }, [actionStatus, actionName]);

  

  // Push data into dataLayer
  const addDataLayer = () => {
    const data = {
      project: 'Alumni',
      event: 'gtm.load',
      js: new Date(),
      utm_source: 'tal_reg',
      utm_medium: searchParams.get("utm_medium")
    }
    pushGoogleAnalytics(data);
  };

  const validateFormData = () => {
    let formErrors = { company: "", first_name: "", last_name: "", email: "", password: "",
      password2: "", yearOfBirth: "", monthOfBirth: "", dateOfBirth: "", referer: "",
      department: "", yearOfJoin: "", monthOfJoin: "", yearOfLeave: "",
      reason: "", gender: "", otherReason: "" 
    };

    if (!companyInfo.id) {
      formErrors.company = "登録先企業必須です。";
    }

    if (!formData.first_name) {
      formErrors.first_name = "名は必須です。";
    }

    if (!formData.last_name) {
      formErrors.last_name = "姓は必須です。";
    }

    if(!formData.last_name_kana) {
      formErrors.last_name_kana = "セイは必須です。";
    } else {
      const check_last_name_kana = validateNameKatakana(formData.last_name_kana, 'セイ');
      if (check_last_name_kana !== true) {
        formErrors.last_name_kana = check_last_name_kana
      }
    }
    
    if(!formData.first_name_kana) {
      formErrors.first_name_kana = "メイは必須です。";
    } else {
      const check_first_name_kana = validateNameKatakana(formData.first_name_kana, 'メイ');
      if (check_first_name_kana !== true) {
        formErrors.first_name_kana = check_first_name_kana
      }
    }

    if (!formData.gender) {
      formErrors.gender = "性別は必須です。";
    }

    if (!formData.city) {
      formErrors.city = "居住地は必須です。";
    }

    if (!formData.email) {
      formErrors.email = i18n.t('MSG_GLOBAL_EMAIL_REQUIRED');
    } else {
      const validateEmailRes = validateEmail(formData.email);
      if(validateEmailRes != true) {
        formErrors.email = i18n.t('MSG_GLOBAL_INVALID_EMAIL_FORMAT');
      }
    }

    if (!formData.email2) {
      formErrors.email2 = "メールアドレス（確認）は必須です。";
    } else if(formData.email2 != formData.email) {
      formErrors.email2 = "メールアドレスが一致しません。";
    }

    const minLength = 8;
    const maxLength = 32;
    const hasLowerLetter = /[a-z]/;
    const hasUpperLetter = /[A-Z]/;
    const hasNumber = /[0-9]/;

    if (!formData.password) {
      formErrors.password = "パスワードを設定は必須です。";
    } else if (formData.password.length > maxLength) {
      formErrors.password = "パスワードはアルファベット大文字・小文字、数字を組み合わせて8桁以上32文字以内で設定してください。";
    } else if (formData.password.length < minLength || !hasLowerLetter.test(formData.password) || !hasUpperLetter.test(formData.password) || !hasNumber.test(formData.password)) {
      formErrors.password = "パスワードはアルファベット大文字・小文字、数字を組み合わせて8桁以上で設定してください。";
    }

    if (!formData.password2) {
      formErrors.password2 = "パスワードを設定（確認) は必須です。";
    } else if (formData.password2.length > maxLength) {
      formErrors.password2 = "パスワードはアルファベット大文字・小文字、数字を組み合わせて8桁以上32文字以内で設定してください。";
    } else if (formData.password2.length < minLength || formData.password2.length > maxLength || !hasLowerLetter.test(formData.password2) || !hasUpperLetter.test(formData.password2) || !hasNumber.test(formData.password2)) {
      formErrors.password2 = "パスワードはアルファベット大文字・小文字、数字を組み合わせて8桁以上で設定してください。";
    } else if (formData.password != formData.password2) {
      formErrors.password2 = i18n.t('MSG_GLOBAL_INCORRECT_PASSWORD');
    }

    if (type !== TALENT_TYPE.INTERNAL) {
      if (!formData.profession_1) {
        formErrors.profession_1 = "職種１は必須です。";
      }
      if (!formData.profession_2) {
        formErrors.profession_2 = "職種２は必須です。";
      }
      if (!formData.profession_3) {
        formErrors.profession_3 = "職種３は必須です。";
      }
      if (!formData.industry1) {
        formErrors.industry1 = "業種１は必須です。";
      }
      if (!formData.industry2) {
        formErrors.industry2 = "業種２は必須です。";
      }
      if (!formData.industry3) {
        formErrors.industry3 = "業種３は必須です。";
      }
    }
    if (!formData.yearOfBirth || !getValueByObject(formData.yearOfBirth)) {
      formErrors.yearOfBirth = "西暦は必須です";
    } 
    if (!formData.monthOfBirth || !getValueByObject(formData.monthOfBirth)) {
      formErrors.monthOfBirth = "月は必須です";
    } 
    if (!formData.dateOfBirth || !getValueByObject(formData.dateOfBirth)) {
      formErrors.dateOfBirth = "日は必須です";
    }

    if(type === TALENT_TYPE.ALUMNI) {
      if (!formData.department) {
        formErrors.department = "最終部署・社名は必須です。";
      }
      if (!formData.yearOfLeave) {
        formErrors.yearOfLeave = "西暦は必須です。";
      }
    }

    const check_join_company_date = isValidJoinDateLeaveDate(formData?.yearOfJoin?.id, formData.monthOfJoin?.id, formData.yearOfLeave?.id, formData.monthOfLeave?.id);
    if (check_join_company_date !== true && !formErrors.yearOfJoin && !formErrors.monthOfJoin) {
      formErrors.yearOfJoin = '入社年月は退社年月より後にできない。'
    }

    for (let item of selectedOptions) {
      if (item == 'その他' && (!formData.otherReason || !formData.otherReason.trim())) {
          formErrors.otherReason = 'その他を選択した場合は必須です。'
          break
      }
    }

    setErrors(formErrors);
    return !Object.values(formErrors).some((error) => error);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (isLoadingRegister) { return; }
    if (!validateFormData()) {
      // Scroll to first error
      setTimeout(() => {
        const firstError = document.querySelector("p.alu-text-error");
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 200);
      return;
    }

    let resignation_reason = "";
    for (let item of selectedOptions) {
        if (item == 'その他') {
            resignation_reason += formData.otherReason + " | "
        } else {
            resignation_reason += item + " | "
        }
    }
    resignation_reason = resignation_reason.endsWith(" | ") ? resignation_reason.slice(0, -3) : resignation_reason
    
    dispatch(setIsLoadingRegister(true))

    const data = {
      ...formData,
      company_id: companyInfo.id,
      referrer_talent_id: referrer_talent_id,
      type: type,
      register_code: register_code,
      city: getNameByObject(formData.city),
      referer: formData.referer,
      resignation_reason: resignation_reason != "" ? resignation_reason : null,
      token: token,
      gender_id: formData.gender?.id || null,
      occupation_1_id: formData.profession_1?.id || null,
      occupation_2_id: formData.profession_2?.id || null,
      occupation_3_id: formData.profession_3?.id || null,
      industry_1_id: formData.industry1?.id || null,
      industry_2_id: formData.industry2?.id || null,
      industry_3_id: formData.industry3?.id || null,
      employee_number: formData.employee_number || null,
      birth_year: formData?.yearOfBirth?.id ? formData?.yearOfBirth?.id : null,
      birth_month: formData?.monthOfBirth?.id ? formData?.monthOfBirth?.id : null,
      birth_day: formData?.dateOfBirth?.id ? formData?.dateOfBirth?.id : null,
      join_company_year: formData?.yearOfJoin?.id ? formData?.yearOfJoin?.id : null,
      join_company_month: formData?.yearOfJoin?.id && formData?.monthOfJoin?.id ? formData?.monthOfJoin?.id : null,
      leave_company_year: formData?.yearOfLeave?.id ? formData?.yearOfLeave?.id : null,
      leave_company_month: formData?.monthOfLeave?.id ? formData?.monthOfLeave?.id : null,
      leave_company_day: formData?.dateOfLeave?.id ? formData?.dateOfLeave?.id : null,
      cv_file_temp_id: formData['CV']?.file ? formData['CV']?.file_id : null,
      resume_file_temp_id: formData['RESUME']?.file ? formData['RESUME']?.file_id : null,
      other_file_temp_id: formData['OTHER']?.file ? formData['OTHER']?.file_id : null,
    };
    const { CV, RESUME, OTHER, ...cleanData } = data;
    dispatch(register({ requestBody: cleanData }));
  }; 

  const showToast = (title: string, message: string, variant: string, textLink: string = "", clickOnText: any = "") => {
    enqueueSnackbar("I love snacks.", {
      autoHideDuration: 7000,
      content: (key) => (
        <CustomToast title={title} message={message} variant={variant} textLink={textLink} clickOnText={clickOnText} snackbarKey={key} closeSnackbar={closeSnackbar} />
      ),
    });
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBlur = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value.trim(),
    }));
  };

  const getValueByObject = (object: any) => {
    if (!object) {
      return null;
    }
    return object.id;
  };
  
  // Access to this page is denied
  if (checkingAccess) {
    return null;
  }
  if (!companyInfo?.id || !type) {
    return <NotFoundPage customRedirectLink={sessionStorage.getItem('talent_registration_url')} isShowSubmitButton={isShowTopPageUrl} />;
  } else {
    const urlSlug = `/new/${TYPE_MAP[type]}/${companyInfo.url_slug}`;
    sessionStorage.setItem('talent_registration_url', urlSlug);
  }
  
  return (
      <div className='static md:inset-0 bg-alu-base min-h-screen'>
          <div className="w-full bg-white">
            <div className='md:max-w-[50rem] static mx-auto py-2 md:py-4 md:px-[2.25rem] text-left'>
              { companyInfo?.logo &&
                <img src={companyInfo?.logo} alt="logo" className="pl-6 md:pl-10 aspect-[8/1] w-auto h-8 object-contain object-left" />
              }
            </div>
          </div>
          <div className='w-full md:max-w-[50rem] static mx-auto md:pb-[2.5rem] md:px-[2.25rem]'>
              <h2 className="px-6 md:px-10 text-xl md:text-xl font-bold alu-text-base-2 py-4 md:pb-4 md:pt-6">{companyInfo?.name}</h2>
              <div className='bg-white md:rounded-2xl md:shadow-lg md:max-w-full md:m-auto md:min-h-max min-h-screen w-full py-0 md:py-6 md:px-[2.5rem]'>
                  <Header title="新規登録" logoDirection="row" hasBorderBottom={false} hasLogoInDesktop={true} ></Header>
                  <RegistrationForm 
                    formData={formData}
                    setFormData={setFormData}
                    errors={errors} onSubmit={handleSubmit}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    options={optionsList}
                    setters={settersList}
                    getValueByObject={getValueByObject}
                  />
              </div>
          </div>
      </div>
  );
};

export default TalentRegistration;
